export default __webpack_public_path__ + "static/media/image.sl-robotics-solutions-pvt-ltd-.fa5a9cac.png";